import { Component, EventEmitter, h, Listen, Prop, Event } from '@stencil/core';
import { FacetChangeEvent, facetChangeValueHandler, FacetUpdateEvent, logDebug } from '@hpfc/fc-frontend-core';

@Component({
  tag: 'fccd-facet-input',
  styleUrl: 'facet-input.scss',
})
export class FacetInput {
  /**
   * The id for the element in this component.
   */
  @Prop() elementId!: string;
  /**
   * The header text.
   */
  @Prop() panelLabel: string;
  /**
   * The help text to display.
   */
  @Prop() inputHelpText: string;
  /**
   * 'true' if the field is required, 'false' otherwise.
   */
  @Prop() required?: boolean = false;
  /**
   * 'true' we should hide the optional label, 'false' otherwise.
   */
  @Prop() hideInputOptionalLabel: boolean = true;

  @Prop({ mutable: true }) initialValue: string;

  /**
   * Dispatches this event when the text is changed.
   */
  @Event() fccdFacetChangeEvent: EventEmitter<FacetChangeEvent>;

  @Listen('hp5InputSearch')
  search(event: CustomEvent) {
    facetChangeValueHandler(this.fccdFacetChangeEvent, event, this.elementId, event.detail, true);
  }

  @Listen('hp5InputSearchClear')
  clear(event: CustomEvent) {
    facetChangeValueHandler(this.fccdFacetChangeEvent, event, this.elementId, null, false);
  }

  @Listen('fccdComponentEvent', { target: 'document' })
  updateHandler(event: CustomEvent<FacetUpdateEvent>) {
    if (event?.detail?.facetMap?.has(this.elementId)) {
      this.initialValue = event.detail.facetMap.get(this.elementId).value;
      logDebug('caught fccdComponentEvent for element: ' + this.elementId);
    } else {
      this.initialValue = '';
    }
  }

  private getPanelName(): string {
    return 'panel-' + this.elementId;
  }

  render() {
    return (
      <div>
        <hp5-filter-panel filter-panel-label={this.panelLabel} label-tag-selection="h3" element-id={this.getPanelName()}>
          <hp5-input-search
            element-id={this.elementId}
            height-selection="md"
            initial-value={this.initialValue}
            input-help-text={this.inputHelpText}
            label={this.panelLabel}
            label-alignment="left"
            label-size="xs"
            label-type="body"
            maxlength={null}
            name={this.elementId}
            required={this.required}
            hide-input-optional-label={this.hideInputOptionalLabel}
          />
        </hp5-filter-panel>
      </div>
    );
  }
}
